"use client";

import { createContext, useContext, useMemo, useState } from "react";

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const [query, setQuery] = useState("");

  const value = useMemo(() => ({ query, setQuery }), [query]);

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
}

export function useStoreSearch() {
  const value = useContext(SearchContext);
  if (!value) {
    throw new Error("useStoreSearch must be used inside SearchProvider.");
  }
  return value;
}
